var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMatch)?_c('div',[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.value)?_c('p',{staticClass:"text-error"},[_vm._v(" "+_vm._s(_vm.t('harvester.backup.matchTarget'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }